"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
}); // @ts-nocheck

var v4_1 = __importDefault(require("uuid/v4"));

var PARTY_TYPES = __importStar(require("./types"));

function initialState(type) {
  var base = {
    class: "party",
    type: type,
    name: {
      display: null
    },
    phone: null,
    email: null,
    address: {}
  };

  if (type === PARTY_TYPES.DEBTOR) {
    base = _objectSpread(_objectSpread({}, base), {}, {
      name: {
        first: null,
        middle: null,
        last: null,
        suffix: null
      },
      altNames: [],
      signature: null,
      pastAddresses: [],
      ssns: [],
      // ssn: null, // In use SSN
      itins: [],
      // itin: null, // In use ITIN
      businessNames: [],
      eins: [],
      district: {
        "180Days": true,
        reason: null
      },
      // Course Certificate (#1?)
      creditBriefing: {
        exempt: false,
        status: null
      },
      // Pay Stub Doc
      payRecord: {
        included: false,
        reason: null,
        additionalDescription: null
      },
      // Tax Returns
      taxRecord: {
        included: false
      } // income: {}, // NOTE: Summary

    });
  } else if (type === PARTY_TYPES.DEPENDENT) {
    base = _objectSpread(_objectSpread({}, base), {}, {
      age: null,
      relationship: null,
      livesWithDebtor: null
    });
  } else if (type === PARTY_TYPES.BUSINESS) {
    base = _objectSpread(_objectSpread({}, base), {}, {
      domain: null,
      ein: null,
      startedAt: null,
      endedAt: null
    });
  } else if (type === PARTY_TYPES.GOVERNMENT) {
    base = _objectSpread(_objectSpread({}, base), {}, {
      politicalLevel: null // NOTE: 'federal', 'state', 'local'

    });
  }

  return base;
}

var createParty = function createParty() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread(_objectSpread(_objectSpread({}, initialState(attrs.type)), attrs), {}, {
    id: (0, v4_1.default)()
  });
};

exports.default = createParty;